import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFEvent = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 22 22",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M15.56,6.77c-1.2-1.44-2.23-2.67-2.23-4.63a.64.64,0,0,0-.95-.56C9.16,3.4,8.84,7.21,8.88,9a1.39,1.39,0,0,1-.55-.85,1.24,1.24,0,0,0-.81-.87,1.19,1.19,0,0,0-1.12.19A7.39,7.39,0,0,0,3.8,15a7.39,7.39,0,0,0,5.85,5.4,7.54,7.54,0,0,0,6.17-1.63,7.23,7.23,0,0,0,2.59-5.53C18.41,10.17,16.9,8.36,15.56,6.77ZM11,18c-1.3,0-2.7-.62-2.7-2.33,0-.83.93-2.22,2.47-3.71a.33.33,0,0,1,.23-.09.31.31,0,0,1,.22.09c1.55,1.49,2.47,2.88,2.47,3.71C13.69,17.42,12.3,18,11,18Z" })
});
export default SvgFEvent;
